import { Achievement } from '../../services/mypageService';
import './AchievementsSection.css';

interface AchievementsSectionProps {
  achievements: Achievement[];
}

export const AchievementsSection = ({
  achievements,
}: AchievementsSectionProps) => {
  const getTierColor = (tier: string) => {
    switch (tier) {
      case 'diamond':
        return '#b9f2ff';
      case 'platinum':
        return '#e5e4e2';
      case 'gold':
        return '#ffd700';
      case 'silver':
        return '#c0c0c0';
      case 'bronze':
        return '#cd7f32';
      default:
        return '#6b7280';
    }
  };

  return (
    <div className="achievements-grid">
      {achievements.map((achievement) => {
        const isUnlocked = achievement.isUnlocked;
        return (
          <div
            key={achievement.achievementId}
            className={`achievement-item ${!isUnlocked ? 'locked' : ''}`}
            style={{
              borderColor: getTierColor(achievement.tier),
              opacity: isUnlocked ? 1 : 0.5,
            }}
          >
            <div className="achievement-icon" style={{ opacity: isUnlocked ? 1 : 0.6 }}>
              {achievement.icon || '🏆'}
            </div>
            <div className="achievement-info">
              <div className="achievement-name">{achievement.name}</div>
              <div className="achievement-description">
                {achievement.description}
              </div>
              {isUnlocked && achievement.unlockedAt && (
                <div className="achievement-date">
                  {new Date(achievement.unlockedAt).toLocaleDateString('ko-KR')}
                </div>
              )}
            </div>
            {!isUnlocked && <div className="achievement-locked-badge">🔒</div>}
          </div>
        );
      })}
    </div>
  );
};








